import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import M from 'materialize-css/dist/js/materialize';
import BaseComponent from '../../../../components/BaseComponent';
import { startLoading, endLoading } from '../../../../actions/loadingAction';
import BackButton from '../../../../components/UI/BackButton';
import { checkPermission } from '../../../../services/auth';
import { PERMISSIONS, ENUMS } from '../../../../utils/constants';
import PickingService from '../../../../services/PickingService';

class PickingOnDemand extends BaseComponent {
    componentDidMount = async () => {
        this.props.filter.orderType = ENUMS.eOrderType.Picking.value;
        this.props.getFirstOrder(this.props.filter);
    }

    confirm = () => {
        if (navigator.onLine) {
            if (this.props.order.status === ENUMS.eOrderItemStatus.Waiting.value) {
                this.props.startOrder(this.props.order.orderId, () => {
                    this.props.history.push({
                        pathname: `./order/${this.props.order.orderCode}/missions`
                    });
                });
            } else {
                this.props.history.push({
                    pathname: `./order/${this.props.order.orderCode}/missions`
                });
            }
        } else {
            M.toast({ html: this.translate('expedition:picking.select-order-offline'), classes: 'red' });
        }
    };

    render() {
        if (this.props.order && this.props.order.orderCode !== undefined) {
            return (
                <div>
                    {
                        checkPermission(PERMISSIONS.Expedition.Picking.Filters) === true
                            ? <BackButton {...this.props} /> : null
                    }
                    <div className="container-fluid h-65">
                        <div className="row">
                            <div className="title">
                                <i className="mdi mdi-dolly" />
                                {this.translate('expedition:picking.title')}
                            </div>
                            <div className="subtitle">
                                | <i className="material-icons">compare_arrows</i>
                                {this.translate('expedition:picking.ondemand')}
                            </div>
                        </div>
                    </div>
                    <div className="container" style={{ marginTop: '40px', }}>
                        <div className="card">
                            <div className="card-content" style={{ padding: '0px', }}>
                                <div className="row">
                                    <div className="col s12">
                                        <h4>{`${this.translate('expedition:picking.order')} : ${this.props.order.orderCode}`}</h4>
                                        <p className="truncate">{`${this.props.order.supplierCode} - ${this.props.order.supplierName}`}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="card-action row center">
                                <button
                                    type="button"
                                    className="col s12 m3
                                btn
                                btn-principal
                                waves-effect
                                waves-light"
                                    onClick={() => this.confirm(this)}
                                >
                                    {this.translate('general:confirm')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (checkPermission(PERMISSIONS.Expedition.Picking.Filters) === true
                ? <BackButton {...this.props} /> : null);
        }
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        config: state.configReducer.config,
        order: state.pickingReducer.order,
        filter: state.pickingReducer.filter

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getFirstOrder: (filter) => {
            dispatch(PickingService.firstOrder(filter));
        },
        showLoading: () => {
            dispatch(startLoading());
        },
        hideLoading: () => {
            dispatch(endLoading());
        },
        startOrder: (orderId, callback) => {
            dispatch(PickingService.startOrder(orderId, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PickingOnDemand)));
